import React from 'react';
import {Alert, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import config from '../../../config';
import messages from '../../../res/translations/messages';
import {uploadSurveyTrackedUsersFile} from '../../services/api';

class SurveyUploadEmailButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {changed: false, modal: false, results: null, uploading: false};
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        if (this.state.modal && this.state.changed) {
            this.props.onChange();
        } else if (!this.state.model) {
            this.setState({changed: false, results: null});
        }
        this.setState({modal: !this.state.modal});
    }

    async handleFileUpload(e) {
        const file = e.target.files[0];
        e.target.value = null;
        this.setState({uploading: true});
        try {
            const {data} = await uploadSurveyTrackedUsersFile(this.props.item.id, this.props.wave.id, file);
            this.setState({changed: true, results: data});
        } finally {
            this.setState({uploading: false});
        }
    }

    render() {
        const {children, className, disabled, item} = this.props;
        return (
            <a onClick={!disabled ? this.toggleModal : undefined} className={classNames(className, {disabled})}>
                {children}
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.surveys.modals.uploadTrackedUsers.title} values={{name: item.name}} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.surveys.modals.uploadTrackedUsers.body} values={{name: item.name}} />
                        <br />
                        <a href={`${config.publicPath}static/trackers_template.csv`} download>
                            <FontAwesomeIcon icon="file-download" className="mr-2" />
                            <FormattedMessage {...messages.surveys.modals.uploadTrackedUsers.sampleLink} />
                        </a>
                        <form className="mb-3">
                            <input type="file" onChange={this.handleFileUpload} className="form-control-file mt-3" disabled={this.state.uploading}
                                accept=".csv" />
                        </form>
                        {this.state.uploading && <FormattedMessage {...messages.surveys.modals.uploadTrackedUsers.uploading} />}
                        {(this.state.results && !this.state.uploading) && (
                            <Alert color="primary">
                                <FormattedMessage {...messages.surveys.modals.uploadTrackedUsers.results} values={{
                                    inserted: this.state.results.inserted,
                                    total: this.state.results.total,
                                }} />
                            </Alert>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary" type="button" onClick={this.toggleModal} disabled={this.state.uploading}>
                            <FormattedMessage {...messages.buttons.ok} />
                        </button>
                    </ModalFooter>
                </Modal>
            </a>
        );
    }
}

export default SurveyUploadEmailButton;
